"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIEngine = void 0;
var logParams = {
    "toLogInFile": false,
    "toPrint": false,
    "fileToLogIn": "",
    "toLog": {}
};
var AIEngine = /** @class */ (function () {
    function AIEngine(config, log_def) {
        if (log_def === void 0) { log_def = undefined; }
        this.logParams = {};
        this.config = config;
        this.params = this.config.params;
        this.logParams = logParams;
        if (log_def != undefined) {
            for (var key in log_def) {
                if (["toLogInFile", "toPrint"].includes(key)) {
                    this.logParams[key] = log_def[key];
                    logParams[key] = log_def[key];
                }
                else if (key == "toLog") {
                    for (var logKey in log_def[key]) {
                        this.logParams[key][logKey] = log_def[key][logKey];
                        logParams[key][logKey] = log_def[key][logKey];
                    }
                }
            }
        }
    }
    AIEngine.prototype.update = function (activity) { };
    AIEngine.prototype.nextActivity = function () { };
    AIEngine.prototype.isCurriculumFinished = function () {
        return false;
    };
    AIEngine.prototype.sample_from_history = function (history) {
        return {};
    };
    AIEngine.prototype.update_history = function (pastHistory) { };
    AIEngine.prototype.get_full_diagnostic = function (diag_with_statements) {
        if (diag_with_statements === void 0) { diag_with_statements = undefined; }
        return {};
    };
    AIEngine.prototype.get_student_diagnosis = function () {
        return {};
    };
    AIEngine.prototype.get_clean_bandval_state = function () {
        return {};
    };
    return AIEngine;
}());
exports.AIEngine = AIEngine;
